var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendJobBlast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6907 14.4577C9.71603 14.5208 9.76006 14.5747 9.81688 14.6121C9.87371 14.6494 9.9406 14.6685 10.0086 14.6668C10.0766 14.665 10.1424 14.6426 10.1973 14.6023C10.2521 14.5621 10.2933 14.506 10.3154 14.4417L14.6487 1.77503C14.67 1.71596 14.6741 1.65203 14.6604 1.59073C14.6468 1.52943 14.6159 1.47329 14.5715 1.42888C14.5271 1.38447 14.471 1.35363 14.4097 1.33996C14.3484 1.32629 14.2844 1.33036 14.2254 1.3517L1.5587 5.68503C1.49436 5.70709 1.43832 5.74831 1.39808 5.80314C1.35785 5.85798 1.33535 5.92381 1.33361 5.9918C1.33186 6.05979 1.35096 6.12669 1.38834 6.18351C1.42571 6.24034 1.47958 6.28437 1.5427 6.3097L6.82937 8.4297C6.99649 8.49661 7.14833 8.59667 7.27574 8.72385C7.40315 8.85103 7.50349 9.00269 7.5707 9.1697L9.6907 14.4577Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5692 1.42969L7.27588 8.72235",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendJobBlast);
export default __webpack_public_path__ + "static/media/sendJobBlast.7967527376ec8c8bd49c15732531a646.svg";
export { ForwardRef as ReactComponent };